/**
 * Resolves a media path to a full URL if it's relative.
 * Handles /uploads/ paths by prepending the API base URL.
 */
export const getMediaUrl = (path: string | null | undefined): string | undefined => {
  if (!path) return undefined;
  if (path.startsWith('http')) return path;
  
  // Get API URL: try localStorage first (saved by Electron) or fallback to env
  const savedServerUrl = localStorage.getItem('erp_server_url');
  const apiUrl = savedServerUrl ? `${savedServerUrl}/api/v1` : (import.meta.env.VITE_API_URL || '');
  
  // If the path is relative (/uploads/...), prepend the domain
  if (path.startsWith('/uploads')) {
    // Strip trailing /api/v1 if it exists in the apiUrl to get the base domain
    const baseDomain = apiUrl.replace(/\/api\/v1\/?$/, '');
    return `${baseDomain}${path}`;
  }
  
  return path;
};
